import React, { lazy, Suspense } from "react";
import { Route, Switch, Redirect, BrowserRouter } from "react-router-dom";
import { useSelector } from "react-redux";

import routes from "./routes";
import AuthenticatedRoute from "./AuthenticatedRoute";
import UnauthenticatedRoute from "./UnauthenticatedRoute";
import CommonRoute from "./CommonRoute";

import Fallback from "./Fallback";
import { hasPermission } from "../lib/utils";
// import config from "./../config";
// import Main from '../components/layout/Main'
// import CommonRoute from './CommonRoute';

const AccountLogin = lazy(() => import("../pages/Auth/Login"));

const Register = lazy(() => import("../pages/Auth/SignUp"));
const ForgotPassword = lazy(() => import("../pages/Auth/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/Auth/ResetPassword"));
const Calculator = lazy(() => import("../pages/Auth/Calculator"));

const VerifyAccount = lazy(() => import("../pages/Auth/VerifyAccount"));
const DefaultPage = lazy(() => import("../components/layout/DefaultLayout"));

// const Home = lazy(() => import('../containers/Home/Home'));

const defaultTitle = "The LendingTree ";

const Router = (props) => {
  const { childProps } = props;
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const rawPermission = useSelector(
    (state) => state?.auth?.user?.role?.permission?.permission
  );
  const userPermissions = rawPermission
    ? JSON.parse(rawPermission).strPermission
    : [];

  const hasDashboardPermission = hasPermission("dashboard", userPermissions);
  const newRoutes = hasDashboardPermission
    ? routes
    : routes.filter((rt) => {
        return rt.path !== "/dashboard";
      });

  return (
    <BrowserRouter>
      <Suspense fallback={<Fallback />}>
        <Switch>
          {/* {isLoggedIn && */}
          {/* <Main> */}
          {newRoutes.map((route, index) => {
            return (
              <AuthenticatedRoute
                path={route.path}
                exact
                component={route.component}
                title={route.title}
                props={{
                  ...childProps,
                  ...route.props,
                  subName: route.name,
                }}
                key={index}
              />
            );
          })}
          {/* </Main> */}
          {/* } */}

          {/* {!isLoggedIn && */}
          <UnauthenticatedRoute
            path="/login"
            exact
            component={AccountLogin}
            title={"Login - " + defaultTitle}
            props={childProps}
          />

          <Route path="/app" component={DefaultPage} />

          <UnauthenticatedRoute
            path="/register"
            exact
            component={Register}
            title={"Register - " + defaultTitle}
            props={childProps}
          />

          <UnauthenticatedRoute
            path="/verify/:id"
            exact
            component={VerifyAccount}
            title={"Verify Account - " + defaultTitle}
            props={childProps}
          />

          <UnauthenticatedRoute
            path="/forget-password"
            exact
            component={ForgotPassword}
            title={"Forgot Password - " + defaultTitle}
            props={childProps}
          />

          <UnauthenticatedRoute
            path="/reset-password/:token/:userId"
            exact
            component={ResetPassword}
            title={"Reset Password - " + defaultTitle}
            props={childProps}
          />
          {/* } */}

          <CommonRoute
            path="/calculator"
            component={Calculator}
            title={"Calculator"}
            props={childProps}
          />
          {/* <UnauthenticatedRoute
            path="/calculator"
            exact
            component={Calculator}
            title={"Calculator - " + defaultTitle}
            props={childProps}
          /> */}

          {/* <UnauthenticatedRoute
                        path="/register"
                        exact
                        component={Register}
                        title={'Register - ' + defaultTitle}
                        props={childProps}
                    /> */}

          {/* <UnauthenticatedRoute
            path="/register/redirect"
            exact
            component={RegisterRedirect}
            title={'Register Redirect - ' + defaultTitle}
            props={childProps}
          /> */}

          {/* <UnauthenticatedRoute
            path="/account/forgotpassword"
            exact
            component={ForgotPassword}
            title={'Forgot Password - ' + defaultTitle}
            props={childProps}
          /> */}

          {/* <CommonRoute
            path={'/auth/confirm-account/:token'}
            exact
            component={ConfirmEmail}
            title={'Confirm Email - ' + config.REACT_APP_TENANT_SHORT_NAME}
            props={childProps}
          /> */}

          {/* <CommonRoute
            path={'/auth/newpassword/:token'}
            exact
            component={ChangePassword}
            title={'Set Password - ' + config.REACT_APP_TENANT_SHORT_NAME}
            props={{ ...childProps, newPassMode: true }}
          /> */}

          {/* <CommonRoute
            path={'/auth/resetpassword/:token'}
            exact
            component={ChangePassword}
            title={'Reset Password - ' + config.REACT_APP_TENANT_SHORT_NAME}
            props={{ ...childProps, newPassMode: false }}
          /> */}

          <Route
            props={childProps}
            render={(routeProps) => (
              <Redirect
                to={
                  isLoggedIn
                    ? hasDashboardPermission
                      ? "/dashboard"
                      : newRoutes[0].path
                    : "/login"
                }
              />
            )}
          />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
};

export default Router;
